import { IonCol, IonContent, IonGrid, IonPage, IonRow } from '@ionic/react';
import { ReactElement } from 'react';
import { LoginPasswordConfirm } from '../../components/login/login-password-confirm';
import { LoginWelcome } from '../../components/login/login-welcome';
import './login.css';

const LoginPasswordConfirmPage = (): ReactElement => {
  return (
    <IonPage>
      <IonContent>
        <IonGrid className="login-page-container ion-no-padding">
          <IonRow>
            <IonCol sizeMd="6" sizeXs="12" pushMd="6" pushXs="0">
              <LoginPasswordConfirm />
            </IonCol>
            <IonCol sizeMd="6" sizeXs="12" pullMd="6" pullXs="0">
              <LoginWelcome />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export { LoginPasswordConfirmPage };
